const InfoReceiverAndSender = ({ infoUser = {} }) => {
  const { title, name, phoneNumber, address } = infoUser;
  return (
    <div className="info-receiver-and-sender">
      <b>{title}</b>
      <div style={{ flex: 1 }}>
        <div className="info-address">
          <div>
            <span>
              <b>{name}</b>
              {phoneNumber ? `| ${phoneNumber}` : null}
            </span>
          </div>
          <span>{address}</span>
        </div>
      </div>
    </div>
  );
};

export default InfoReceiverAndSender;
